type CookiesAcceptanceData = {
  accepted: boolean;
  expires: number;
};

type CookiesModalOptions = {
  containerClass?: string;
  buttonClass?: string;
  storageKey?: string;
  expirationDays?: number;
};

function safeParseAcceptanceData(raw: string): CookiesAcceptanceData | null {
  try {
    const data = JSON.parse(raw) as Partial<CookiesAcceptanceData> | null;
    if (!data || typeof data !== 'object') return null;
    if (typeof data.expires !== 'number') return null;
    return { accepted: Boolean(data.accepted), expires: data.expires };
  } catch {
    return null;
  }
}

export function initCookiesModal({
  containerClass = 'cookie',
  buttonClass = 'cookie__btn',
  storageKey = 'cookiesAccepted',
  expirationDays = 7
}: CookiesModalOptions = {}): void {
  const container = document.querySelector<HTMLElement>(`.${containerClass}`);
  const button = document.querySelector<HTMLElement>(`.${buttonClass}`);

  if (!container || !button) return;

  const now = Date.now();
  const stored = localStorage.getItem(storageKey);
  const storedData = stored ? safeParseAcceptanceData(stored) : null;

  if (!storedData || now > storedData.expires) {
    container.classList.add('show');
  }

  button.addEventListener('click', e => {
    e.preventDefault();
    container.classList.remove('show');

    const safeDays = Number.isFinite(expirationDays) ? expirationDays : 7;
    const expirationDate = new Date();
    expirationDate.setDate(expirationDate.getDate() + safeDays);

    const acceptanceData: CookiesAcceptanceData = {
      accepted: true,
      expires: expirationDate.getTime()
    };

    localStorage.setItem(storageKey, JSON.stringify(acceptanceData));
  });
}